import script from "./topBar.vue?vue&type=script&setup=true&lang=js"
export * from "./topBar.vue?vue&type=script&setup=true&lang=js"

import "./topBar.vue?vue&type=style&index=0&id=1704d858&lang=less"
import "./topBar.vue?vue&type=style&index=1&id=1704d858&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1704d858"]])

export default __exports__